import { RefObject } from 'react';

export type UseRefocusTriggerOnCloseParams = {
  triggerRef: RefObject<HTMLButtonElement | null>;
  enabled: boolean;
};

export type UseRefocusTriggerOnCloseReturn = {
  refocusTrigger: () => void;
};

/**
 * Handle refocusing trigger element when popover closes.
 * Improves keyboard navigation and accessibility by returning focus to the trigger.
 */
export function useRefocusTriggerOnClose({
  triggerRef,
  enabled,
}: UseRefocusTriggerOnCloseParams): UseRefocusTriggerOnCloseReturn {
  const refocusTrigger = () => {
    if (!enabled) return;

    const triggerEl = triggerRef?.current;
    if (!triggerEl) return;

    if (triggerEl instanceof Element) {
      if (triggerEl instanceof HTMLButtonElement) {
        triggerEl.focus();
      } else {
        const elAsElement = triggerEl as HTMLElement;
        const firstButton = elAsElement.querySelector('button') as HTMLButtonElement | undefined;
        if (firstButton) {
          firstButton.focus();
        }
      }
    }
  };

  return {
    refocusTrigger,
  };
}
